export enum PreferenceEnum {
  Trending = 'Trending',
  Featured = 'Featured',
  Recent = 'Recent',
  Relevant = 'Relevant',

}
